import React, { useMemo } from 'react';
import { Spinner } from '../../../../common';
import { AttributePreview } from '../../../../pages/CMSPages/MeteoStation/components/AttributePreview';
import { AttributeIconRenderer } from '../../../../pages/CMSPages/MeteoStation/components/AttributeIconRenderer';
import { Link } from 'react-router-dom';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { useTranslation } from 'react-i18next';
import { useGetOrderedAttributesQuery } from '../../../../../redux/services/sensorAttributes';
import { LastUpdatedAt } from '../../../../pages/PublicPages/MeteoStation/components/LastUpdatedAt';
import { getFirstCreatedAtFromSensorAttributes } from '../../../../../utils/helpers/CommonHelper';

export function MeteoStationBlock() {
  const { t } = useTranslation();

  const { data: orderedAttributes, isLoading } = useGetOrderedAttributesQuery();

  const lastUpdatedAt = useMemo(
    () => getFirstCreatedAtFromSensorAttributes(orderedAttributes || []),
    [orderedAttributes],
  );

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <LastUpdatedAt lastUpdatedAtString={lastUpdatedAt} />

      <div className="meteo-station-block-wrapper">
        {(orderedAttributes || []).map((attribute) => (
          <AttributePreview
            key={attribute.id}
            title={attribute.label}
            value={attribute.sensor_value?.value}
            unit={attribute.attribute_unit.unit}
            icon={<AttributeIconRenderer attribute={attribute} />}
          />
        ))}
      </div>

      <Link to={routes.meteoStation} className="meteo-station-block-link">
        {t('Detailnejšie údaje')}
      </Link>
    </>
  );
}
